/* eslint-disable react-hooks/exhaustive-deps */

import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { isBloomberg } from '../util';
import { appRefreshCounterState } from '../states';

// bloomberg cannot use window.location.reload as it will crash the app
// so mimic that behavior for bloomberg by setting a key in App.tsx
// and incrementing it here to manually cause React to refresh the app
const useRefresh = () => {
  const [appRefreshCounter, setAppRefreshCounter] = useRecoilState(
    appRefreshCounterState,
  );

  const triggerRefresh = useCallback(() => {
    if (!isBloomberg()) {
      return window.location.reload();
    }
    setAppRefreshCounter(appRefreshCounter + 1);
  }, [appRefreshCounter]);

  return { triggerRefresh };
};

export default useRefresh;
